import { __extends } from "tslib";
import { get } from '@antv/util';
import ApplyResponsiveLabel from '../../../util/responsive/apply/label';
var ApplyResponsiveColumnLabel = /** @class */ (function (_super) {
    __extends(ApplyResponsiveColumnLabel, _super);
    function ApplyResponsiveColumnLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ApplyResponsiveColumnLabel.prototype.getType = function () {
        return get(this.plot.options, ['label', 'position'], 'inner');
    };
    return ApplyResponsiveColumnLabel;
}(ApplyResponsiveLabel));
export default function responsivePointLabel(layer) {
    var responsiveTheme = layer.getResponsiveTheme();
    new ApplyResponsiveColumnLabel({
        plot: layer,
        responsiveTheme: responsiveTheme,
    });
}
//# sourceMappingURL=label.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/plots/column/apply-responsive/label.js
// module id = null
// module chunks = 